import { useCallback, useEffect, useState } from "react";
import { Coins, Send } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, errText } from "@/lib/api";
import { coinLabel, formatDate } from "@/lib/constants";

export default function AdminCoins() {
  const { user, refreshMe } = useAuth();
  const [f, setF] = useState({ username: "", amount: "", note: "" });
  const [items, setItems] = useState([]);
  const load = useCallback(() => { api.get("/admin/coins/transfers").then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); refreshMe(); }, [load, refreshMe]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/admin/coins/transfer", { ...f, amount: Number(f.amount) });
      toast.success(`${data.amount} коинов переведено пользователю ${data.to}`);
      setF({ username: "", amount: "", note: "" }); load(); refreshMe();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="grid lg:grid-cols-[380px_1fr] gap-5">
      <form onSubmit={submit} className="rounded-2xl bg-white border border-[#d1e7dd] p-5 space-y-3 h-fit" data-testid="coin-transfer-form">
        <div className="rounded-xl bg-[#0b2e20] text-white p-4">
          <div className="text-xs uppercase tracking-widest text-[#a3e6be] font-bold">Ваш баланс для переводов</div>
          <div className="font-display text-3xl font-extrabold mt-1 flex items-center gap-2" data-testid="transfer-balance"><Coins className="h-6 w-6 text-amber-400" />{coinLabel(user)}</div>
          {user.role !== "admin" && <div className="text-xs text-white/60 mt-1">Коины списываются с вашего баланса</div>}
        </div>
        <Input required placeholder="Юзернейм получателя" value={f.username} onChange={set("username")} data-testid="transfer-username-input" />
        <Input required type="number" min={1} placeholder="Сколько коинов" value={f.amount} onChange={set("amount")} data-testid="transfer-amount-input" />
        <Input placeholder="Комментарий (необязательно)" value={f.note} onChange={set("note")} maxLength={200} data-testid="transfer-note-input" />
        <Button type="submit" className="w-full rounded-full bg-[#1f5f42] hover:bg-[#174731]" data-testid="transfer-submit-button"><Send className="h-4 w-4 mr-1" />Перевести</Button>
      </form>
      <div className="rounded-2xl bg-white border border-[#d1e7dd] divide-y divide-[#eef6f1]" data-testid="transfers-list">
        <div className="p-4 font-display font-bold text-[#0b2e20]">История переводов</div>
        {items.length === 0 && <p className="p-8 text-center text-sm text-[#6b8a7b]">Переводов пока нет</p>}
        {items.map((t) => (
          <div key={t.id} className="p-4 flex items-center gap-3" data-testid={`transfer-row-${t.id}`}>
            <div className="flex-1 min-w-0 text-sm">
              <span className="font-semibold text-[#1f5f42]">{t.from}</span> → <span className="font-semibold text-[#0b2e20]">{t.to}</span>
              {t.note && <span className="text-[#6b8a7b]"> · {t.note}</span>}
              <div className="text-xs text-[#8aa699]">{formatDate(t.created_at)}</div>
            </div>
            <span className="font-bold text-amber-700">+{t.amount}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
